import { Controller } from "@hotwired/stimulus"
import "photoswipe/dist/photoswipe.css"

const FALLBACK_WIDTH = 800
const FALLBACK_HEIGHT = 510

export default class extends Controller {
  // PhotoSwipe is loaded on connect so it stays out of the bundle every page downloads.
  async connect () {
    const connection = (this.connection = Symbol("connection"))
    const slides = this.slideData()
    if (!slides.length) return

    const [{ default: PhotoSwipeLightbox }, { default: PhotoSwipe }] = await Promise.all([
      import("photoswipe/dist/photoswipe-lightbox.esm.js"),
      import("photoswipe/dist/photoswipe.esm.js")
    ])
    if (this.connection !== connection) return // disconnected (or reconnected) while loading

    this.lightbox = new PhotoSwipeLightbox({
      dataSource: slides,
      pswpModule: PhotoSwipe,
      showHideAnimationType: "fade"
    })
    this.lightbox.init()
  }

  disconnect () {
    this.connection = null
    this.lightbox?.destroy()
    this.lightbox = null
  }

  open (event) {
    event?.preventDefault()
    this.loadAndOpen(0)
  }

  openFromSlide (event) {
    const item = event.target.closest(".item")
    if (!item || !this.element.contains(item)) return

    const index = this.items().indexOf(item)
    this.loadAndOpen(Math.max(0, index))
  }

  // Slides are read again on open: by then each <picture> has picked its format (AVIF, WebP…), which
  // `currentSrc` hands to the lightbox straight from the cache instead of downloading another format.
  loadAndOpen (index) {
    this.lightbox?.loadAndOpen(index, this.slideData())
  }

  items () {
    return [...this.element.querySelectorAll(".item")]
  }

  slideData () {
    return this.items().map((item) => {
      const img = item.querySelector("img")
      return {
        src: item.dataset.src || img?.currentSrc || img?.src,
        width: Number(item.dataset.pswpWidth) || img?.naturalWidth || FALLBACK_WIDTH,
        height: Number(item.dataset.pswpHeight) || img?.naturalHeight || FALLBACK_HEIGHT,
        alt: img?.alt || ""
      }
    }).filter((slide) => slide.src)
  }
}
